import { useContext, useEffect, useState } from 'react';

import { GlobalContext } from "../../../contexts/globalContext";
import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';

import PD_BaseListComponent from '../PD_BaseListComponent';
import PD_FileComponent from './PD_FileComponent';
import DarkButtonComponent from '../../commons/DarkButtonComponent';
import PreviewPdfFileComponent from '../../conferenceScreen/filesComponents/PreviewPdfFileComponent';
import PreviewImageFileComponent from '../../conferenceScreen/filesComponents/PreviewImageFileComponent';
import PreviewVideoFileComponent from '../../conferenceScreen/filesComponents/PreviewVideoFileComponent';

const FileListComponent = () => {
    const { socketRef, language, selectedProject, topicFiles, setTopicFiles, selectedTopicIdRef, setAlertMessage, appHeight, appWidth } = useContext(GlobalContext);
    const { setAddFiles } = useContext(ProjectDetailsContext)

    const [topicFilesOpened, setTopicFilesOpened] = useState([])


    useEffect(() => {
        socketRef.current.emit("PROJECT_GET_FOLDER_ATTACHED_DOCUMENTS", { parentId: selectedTopicIdRef.current }, (docs) => {
            setTopicFiles(docs);
        });
    }, [selectedTopicIdRef.current])

    const onClickFile = (file) => {
        if (file.docsFile.type === "site") {
            setAlertMessage({ type: "WARNING", message: "Preview not available for site files." });
            return;
        }

        if (topicFilesOpened.find(f => f.uid === file._id)) {
            setTopicFilesOpened(files => files.filter(a => a.uid !== file._id));
        } else {
            setTopicFilesOpened(files => [...files, {
                uid: file._id, x: 3 * appWidth / 5, y: appHeight / 2, type: file.docsFile.type, path: file.docsFile.path, scale: 1, rotation: 0
            }])
        }
    }

    const getFileComponent = (file) => {
        switch (file.type) {
            case "pdf":
                return <PreviewPdfFileComponent key={file.uid} file={file} setTopicFilesOpened={setTopicFilesOpened} />
            case "image":
                return <PreviewImageFileComponent key={file.uid} file={file} setTopicFilesOpened={setTopicFilesOpened} />
            case "video":
                return <PreviewVideoFileComponent key={file.uid} file={file} setTopicFilesOpened={setTopicFilesOpened} />
            default:
                return "";
        }
    }

    return (
        <>
            <PD_BaseListComponent
                title={language.project_details.Files}
                list={topicFiles.length > 0 && topicFiles.map((file) => (
                    <PD_FileComponent key={file._id} file={file} onClickFile={() => onClickFile(file)} />
                ))}
                button={
                    <DarkButtonComponent onClick={() => selectedProject.topics.length > 0 ? setAddFiles(true) : setAlertMessage({ type: "WARNING", message: "Files can only be added to folders. Select or create a folder to proceed." })} style={{ width: 1125, marginLeft: -57, marginBottom: 57, backdropFilter: "blur(31px)", opacity: selectedProject.topics.length > 0 ? 1 : 0.5 }}>
                        {/* <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['files']} /> */}
                        {language.project_details['Add files']}
                    </DarkButtonComponent>
                }
            />
            {topicFilesOpened.map((file) => (
                getFileComponent(file)
            ))}
        </>
    );

}

export default FileListComponent;